export default {
    customers_list: null
};
